<template>
  <div class="content-box">
    <div class="black-box"></div>
    <div class="load" :class="acuInfo.class">
      <div class="img flex flex-center">
        <img src="@/assets/imgs/yh.png" style="height: 100px" />
      </div>
      <div class="load-data">
        <list-info-3 :value="acuInfo.power" unit="kW"></list-info-3>
      </div>
    </div>
  </div>
</template>

<script>
import listInfo3 from "./list-info3.vue";
export default {
  components: { listInfo3 },
  props: {
    acuInfo: {
      type: Object,
      default() {
        return {
          power: 0,
          class: "",
        };
      },
    },
  },
  watch: {
    acuInfo(newValue) {
      this.acuInfo = newValue;
    },
  },
};
</script>

<style scoped>
.black-box {
  height: 200px;
  width: 150px;
}
.load {
  position: relative;
}
.load-data {
  position: absolute;
  width: 100px;
  left: 20%;
  top: -80%;
}
.load:before {
  content: "";
  position: absolute;
  width: 2px;
  height: 200px;
  background-image: linear-gradient(to top, #01feff, transparent);
  background-size: 100% 100%;
  height: 110px;
  top: -115%;
  left: 50%;
}

.loadTop {
  position: relative;
}
.loadTop:before {
  content: "";
  position: absolute;
  width: 2px;
  height: 200px;
  background-image: linear-gradient(to top, transparent, #01feff);
  background-size: 100% 50%;
  height: 110px;
  top: -115%;
  left: 50%;
  animation: dongTop 2s linear infinite;
}

.loadBottom {
  position: relative;
}
.loadBottom:before {
  content: "";
  position: absolute;
  width: 2px;
  height: 200px;
  background-image: linear-gradient(to top, #01feff, transparent);
  background-size: 100% 50%;
  height: 110px;
  top: -115%;
  left: 50%;
  animation: dongBottom 2s linear infinite;
}
@keyframes dongLeft {
  0% {
    background-position: 100%;
  }

  100% {
    background-position: 0%;
  }
}

@keyframes dongRight {
  0% {
    background-position: 0%;
  }

  100% {
    background-position: 100%;
  }
}

@keyframes dongBottom {
  0% {
    background-position: 0% 0%;
  }

  100% {
    background-position: 0% 100%;
  }
}

@keyframes dongTop {
  0% {
    background-position: 0% 100%;
  }

  100% {
    background-position: 0% 0;
  }
}
</style>
